import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row pad-m" }
const _hoisted_2 = ["value", "disabled", "checked"]
const _hoisted_3 = ["disabled"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esInputCheckbox',
  props: {
    disabled: { type: Boolean },
    value: {},
    label: {},
    checked: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const classList = computed(() => {
  const colorDisabled = props.disabled ? 'color-disabled' : ''


  return ['mleft-06', colorDisabled]
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      id: "es-checkbox",
      name: "es-checkbox",
      value: _ctx.value,
      class: _normalizeClass(_ctx.disabled ? 'color-disabled' : ''),
      disabled: _ctx.disabled,
      checked: _ctx.checked
    }, null, 10, _hoisted_2),
    _createElementVNode("label", {
      for: "es-checkbox",
      class: _normalizeClass(classList.value),
      disabled: _ctx.disabled
    }, _toDisplayString(_ctx.label), 11, _hoisted_3)
  ]))
}
}

})